/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Butberechtigung3Inputs */

const de__field_butberechtigung3 = /** @type {(inputs: _Field_Butberechtigung3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`BuT-Berechtigung`)
};

/**

* @param {_Field_Butberechtigung3Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_butberechtigung3 = /** @type {((inputs?: _Field_Butberechtigung3Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Butberechtigung3Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_butberechtigung3(inputs)
});
export { _field_butberechtigung3 as "_field_BuTBerechtigung" }